module.exports = __webpack_public_path__ + "media/victory4.666945ec.wav";